import classNames from 'classnames';
import {Link} from 'gatsby';
import iconComachi from "images/logo.png";
import React from 'react';
import Style from 'styles/components/footer.module.scss';

const Footer = () => {
  return (
    <>
      <div className={classNames(Style.footer)}>
        <div className={classNames(Style.footer__img)}>
          <a href="/">
            <img className={Style.footer__logo} src={iconComachi} alt="ComachiCart ロゴ" />
          </a>
        </div>
        <div className={classNames(Style.footer__container)}>
        <p className={Style.footer__title}>サービス紹介</p>
          <div className={classNames(Style.footer__listContainer)}>
            <div className={classNames(Style.footer__column)}>
              <ul>
                <li><Link to="/func/">機能</Link></li>
                <li><Link to="/design/">デザイン</Link></li>
                <li><Link to="/price/">料金</Link></li>
                <li><Link to="/case_study/">事例</Link></li>
              </ul>
            </div>
            <div className={classNames(Style.footer__column)}>
              <ul>
                <li><Link to="/know_how/">運営ノウハウ</Link></li>
                <li><Link to="/news/">お知らせ</Link></li>
              </ul>
            </div>
            <div className={classNames(Style.footer__column)}>
              <ul>
                <li><Link to="/faq/">よくある質問</Link></li>
                <li><Link to="https://e-ize.jp/contact/">お問い合わせ</Link></li>
                <li><Link to="https://e-ize.jp/tokushoho/">特商法表記</Link></li>
              </ul>
            </div>
          </div>
          <div className={classNames(Style.footer__column)}>
            <p className={Style.footer__title}>企業情報</p>
            <ul>
              <li><Link to="https://e-ize.jp/">運営会社</Link></li>
              <li><Link to="https://e-ize.jp/recruit/">採用情報</Link></li>
              <li><Link to="https://e-ize.jp/privacy/">プライバシーポリシー</Link></li>
            </ul>
          </div>
        </div>
        <div className={Style.footer__copyright}>
          <p>Copyright© e-ize Co.Ltd. All Rights Reserved.</p>
        </div>
      </div>


    </>
  );
};

export default Footer;
